/**
 * Utility for route-specific authentication handling
 */

// Define all public routes that don't require authentication
export const PUBLIC_ROUTES = [
  '/',
  '/home',
  '/login',
  '/fallback',
  '/custom'
];

/**
 * Determines if a route should be treated as public
 * Public routes can render without authentication and shouldn't throw auth errors
 */
export function isPublicRoute(pathname: string | null): boolean {
  if (!pathname) return false;
  
  // Check exact matches first
  if (PUBLIC_ROUTES.includes(pathname)) {
    return true;
  }
  
  // Check for specific path patterns
  if (
    pathname.startsWith('/login') || 
    pathname.startsWith('/fallback') ||
    pathname.startsWith('/custom')
  ) {
    return true;
  }
  
  return false;
}